import { formatDate, parseISO, differenceInYears } from 'date-fns';

/** ISO 8601 date format (e.g. 2026-04-13) */
export const ISO_DATE_FORMAT = 'yyyy-MM-dd';

export const formatDateWithTime = (date: Date, format: string = 'MM/dd/yyyy, h:mm aa') => {
  return formatDate(date, format);
};

export const formatDateWithoutTime = (date: Date, format: string = 'MM/dd/yyyy') => {
  return formatDate(date, format);
};

/**
 * Formats a date string or Date object to a string with the given format.
 * If the date string does not contain a time, it will be formatted as a date without time. Default Format: `MM/dd/yyyy`
 * If the date string contains a time, it will be formatted as a date with time. Default Format: `MM/dd/yyyy, h:mm aa`
 * Custom formatting is supported.
 * @param date - The date string or Date object to format.
 * @param format - The format to use for the date string.
 * @returns {string} The formatted date string.
 */
export const formatDateTime = (date: string | Date, format?: string) => {
  if (typeof date === 'string' && !date.includes('T')) {
    return formatDateWithoutTime(parseISO(date), format);
  }
  return formatDateWithTime(new Date(date), format);
};

export const isWithinOneYear = (startDate: Date, endDate: Date) => {
  return differenceInYears(endDate, startDate) < 1;
};
